<template>
  <div class="entry-info-container">
    <h1 class="main-title">入驻资料</h1>

    <!-- 1、企业信息 -->
    <section class="section-block">
      <h2 class="sub-title">1、企业信息</h2>
      <div class="table-wrapper">
        <table class="info-table">
          <colgroup>
            <col class="col-type" />
            <col class="col-detail" />
            <col class="col-requirement" />
          </colgroup>
          <thead>
            <tr>
              <th class="cell-center">主体类型</th>
              <th class="cell-center">资质明细</th>
              <th class="cell-center">资质要求</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="cell-center cell-bold">中国大陆主体</td>
              <td>
                1、营业执照复印件，参考详见
                <a
                  href="javascript:void(0)"
                  class="doc-link"
                  @click="$router.push('/businessLicense')"
                >
                  <span class="doc-icon">📰</span>营业执照模板
                </a>
              </td>
              <td>1、需加盖公章，大小5M以内，支持jpg，png格式的图片</td>
            </tr>
            <tr>
              <td class="cell-center cell-bold">非中国大陆主体</td>
              <td>
                <div class="item-line">
                  1、注册登记证明（CR）；若为中国香港主体，还需上传商业登记证（BR）
                </div>
                <div class="item-line">
                  2、公司银行开户证明或银行对账单及翻译件
                </div>
                <div class="item-line tip-text">
                  注：若存在变更，请一并上传变更文件
                </div>
              </td>
              <td>1、需加盖公章，大小5M以内，支持jpg，png格式的图片</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- 2、境内法人信息/境外授权信息 -->
    <section class="section-block">
      <h2 class="sub-title">2、境内法人信息/境外授权信息</h2>
      <div class="table-wrapper">
        <table class="info-table">
          <colgroup>
            <col class="col-type" />
            <col class="col-detail" />
            <col class="col-requirement" />
          </colgroup>
          <thead>
            <tr>
              <th class="cell-center">主体类型</th>
              <th class="cell-center">资质明细</th>
              <th class="cell-center">资质要求</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="cell-center cell-bold">中国大陆主体</td>
              <td>1、法人身份证正、反面复印件</td>
              <td>1、大小5M以内，支持jpg，png格式的图片</td>
            </tr>
            <tr>
              <td class="cell-center cell-bold">非中国大陆主体</td>
              <td>
                <div class="item-line">
                  1、被授权人正反面身份证复印件，若是非中国大陆主体经营者和法定代表人，参考详见
                  <a
                    href="javascript:void(0)"
                    class="doc-link"
                    @click="$router.push('/overseasCertificate')"
                  >
                    <span class="doc-icon">📰</span
                    >非中国大陆主体经营者和法定代表人证件说明
                  </a>
                </div>
                <div class="item-line">
                  2、《签约授权书》，模板详见
                  <a
                    href="javascript:void(0)"
                    class="doc-link"
                    @click="
                      downloadFile(
                        'https://assets-img.milkycloud.au/xlsxs/%E7%AD%BE%E7%BA%A6%E6%8E%88%E6%9D%83%E4%B9%A6.docx'
                      )
                    "
                  >
                    <span class="doc-icon">📰</span>授权代表声明书
                  </a>
                </div>
              </td>
              <td>
                <div class="item-line">
                  1、身份证复印件：加盖公章，大小5M以内，支持jpg，png格式的图片
                </div>
                <div class="item-line">
                  2、《签约授权书》：扫描件，需要开店主体公司CEO或董事签字，并机打签字人姓名及职务，需加盖开店主体公章或开店主体授权签字人手写签名
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- 3、店铺类型 -->
    <section class="section-block">
      <h2 class="sub-title">3、店铺类型</h2>
      <p class="section-tip">商家提前明确店铺类型</p>
      <div class="table-wrapper">
        <table class="info-table">
          <colgroup>
            <col class="col-shop-type" />
            <col class="col-shop-detail" />
          </colgroup>
          <thead>
            <tr>
              <th class="cell-center">店铺类型</th>
              <th class="cell-center">店铺类型介绍</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="cell-center cell-bold">旗舰店</td>
              <td>
                <div class="item-line">
                  1、经营一个自有品牌商品的品牌旗舰店；
                </div>
                <div class="item-line">
                  2、经营多个自有品牌且各品牌归同一实际控制人的品牌旗舰店（邀约制）；
                </div>
                <div class="item-line">
                  3、卖场型品牌（服务类商标）所有者开设的品牌旗舰店（邀约制）；
                </div>
                <div class="item-line">
                  4、开店主体必须是品牌（商标）权利人或持有权利人出具的开设Milky Cloud平台品牌旗舰店排他性授权文件的企业。
                </div>
              </td>
            </tr>
            <tr>
              <td class="cell-center cell-bold">专卖店</td>
              <td>
                <div class="item-line">
                  1、经营一个授权销售品牌商品的专卖店；
                </div>
                <div class="item-line">
                  2、经营多个授权销售品牌且各品牌归同一实际控制人的专卖店（邀约制）；
                </div>
                <div class="item-line">
                  3、品牌（商标）权利人出具的授权文件不得有地域限制。
                </div>
              </td>
            </tr>
            <tr>
              <td class="cell-center cell-bold">专营店</td>
              <td>
                <div class="item-line">
                  1、经营两个及以上他人品牌商品的专营店；
                </div>
                <div class="item-line">
                  2、既经营他人品牌商品又经营自有品牌商品的专营店；
                </div>
                <div class="item-line">
                  3、经营两个及以上自有品牌商品的专营店。
                </div>
              </td>
            </tr>
            <tr>
              <td class="cell-center cell-bold">卖场旗舰店</td>
              <td>
                <div class="item-line">
                  1、商家以服务类型商标（R或TM状态）开设且经营至少两个品牌的店铺；
                </div>
                <div class="item-line">
                  2、开店主体必须是卖场品牌（服务类型商标）的权利人或持有权利人开具的独占性授权书的企业；
                </div>
                <div class="item-line">
                  3、店铺内经营的品牌须提供以商标权人为源头的完整授权或相关资质文件
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- 4、品牌信息 -->
    <section class="section-block">
      <h2 class="sub-title">4、品牌信息</h2>
      <div class="table-wrapper">
        <table class="info-table">
          <colgroup>
            <col class="col-type" />
            <col class="col-detail" />
            <col class="col-requirement" />
          </colgroup>
          <thead>
            <tr>
              <th class="cell-center">品牌类型</th>
              <th class="cell-center">资质明细</th>
              <th class="cell-center">资质要求</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="cell-center cell-bold">自有品牌</td>
              <td>
                <div class="item-line">1、商标注册证</div>
                <div class="item-line">2、品牌logo图</div>
              </td>
              <td>
                <div class="item-line">
                  1、商标注册证：大小5M以内，支持jpg，png格式的图片；如商标正在审核中，请上传商标申请受理通知书
                </div>
                <div class="item-line">
                  2、品牌logo：500*500px长宽，2M以内，格式为jpg或png的图片
                </div>
              </td>
            </tr>
            <tr>
              <td class="cell-center cell-bold">授权品牌</td>
              <td>
                <div class="item-line">在自有品牌资质基础上，还需提供</div>
                <div class="item-line">
                  1、《商标授权书》+《商家授权书》或采销进货凭证，授权书模板详见
                  <a
                    href="javascript:void(0)"
                    class="doc-link"
                    @click="
                      downloadFile(
                        'https://assets-img.milkycloud.au/xlsxs/%E5%95%86%E6%A0%87%E6%8E%88%E6%9D%83%E4%B9%A6%E4%B8%8E%E5%95%86%E5%AE%B6%E6%8E%88%E6%9D%83%E4%B9%A6.docx'
                      )
                    "
                  >
                    <span class="doc-icon">📰</span>商标及商家授权书
                  </a>
                </div>
              </td>
              <td>
                <div class="item-line">
                  1、以商标持有人为源头出发的，授权至开店公司的三级以内完整授权链条。三级授权链路是指：商标持有人→授权方A→授权方B→入驻主体公司，所有授权都要加盖授权方及开店公司红章
                </div>
                <div class="item-line">
                  2、采销链路要求3级以内，采销进货凭证需在3个月内
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <!-- 5、店铺信息 -->
    <section class="section-block">
      <h2 class="sub-title">5、店铺信息</h2>
      <ul class="shop-info-list">
        <li>
          <span class="field-title">店铺名称：</span>填写要求详见
          <a
            href="javascript:void(0)"
            class="doc-link"
            @click="$router.push('/shopNamingRules')"
          >
            <span class="doc-icon">📰</span>店铺命名规范
          </a>
        </li>
        <li>
          <span class="field-title">经营类目：</span>可选类目详见
          <a
            href="javascript:void(0)"
            class="doc-link"
            @click="$router.push('/businessCategory')"
          >
            <span class="doc-icon">📰</span>经营类目
          </a>
        </li>
        <li>
          <span class="field-title">店铺logo图：</span
          >1125*1125px长宽,2M以内，格式为jpg或png的图片
        </li>
        <li>
          <span class="field-title">管理员信息：</span
          >提供管理员姓名、管理员手机号、管理员邮箱信息
        </li>
        <!-- <li>
          <span class="field-title">贸易模式：</span
          >明确是【跨境进口保税模式】，还是【一般贸易模式】
        </li> -->
        <li>
          <span class="field-title">入仓模式：</span
          >明确是【商家仓】，还是【平台仓】，如涉及系统对接，请准备相应接口文档供评估（要求相关接口至少有订单创建、发货回传、取消订单等3个接口）
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: "EntryInfo",
  methods: {
    openLink(url) {
      if (url) {
        window.open(url, "_blank");
      }
    },
    downloadFile(url) {
      if (!url) return;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style lang="less" scoped>
.entry-info-container {
  box-sizing: border-box;
  width: 100%;
  min-height: 100vh;
  padding: 40px 60px;
  background-color: #ffffff;
  color: #262626;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif;
  text-align: left;

  .main-title {
    margin: 0 0 32px 0;
    font-size: 26px;
    font-weight: 700;
    color: #1f1f1f;
    line-height: 1.3;
  }

  .section-block {
    margin-bottom: 36px;

    .sub-title {
      margin: 0 0 16px 0;
      font-size: 18px;
      font-weight: 700;
      color: #1f1f1f;
      line-height: 1.4;
    }

    .section-tip {
      margin: 0 0 12px 0;
      font-size: 14px;
      color: #595959;
      line-height: 1.5;
    }
  }

  .table-wrapper {
    width: 100%;
    overflow-x: auto;
  }

  .info-table {
    width: 100%;
    max-width: 980px;
    border-collapse: collapse;
    border: 1px solid #e8e8e8;
    margin-bottom: 8px;

    .col-type {
      width: 15%;
      min-width: 100px;
    }

    .col-detail {
      width: 45%;
      min-width: 260px;
    }

    .col-requirement {
      width: 40%;
      min-width: 240px;
    }

    .col-shop-type {
      width: 20%;
      min-width: 120px;
    }

    .col-shop-detail {
      width: 80%;
      min-width: 360px;
    }

    th,
    td {
      border: 1px solid #e8e8e8;
      padding: 12px 16px;
      font-size: 13px;
      line-height: 1.6;
      color: #262626;
      vertical-align: middle;
    }

    thead th {
      background-color: #e8f3ff;
      color: #1668dc;
      font-weight: 600;
      font-size: 14px;
    }

    .cell-center {
      text-align: center;
    }

    .cell-bold {
      font-weight: 600;
      color: #262626;
    }

    .item-line {
      margin-bottom: 6px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .tip-text {
      color: #8c8c8c;
      font-size: 12px;
    }
  }

  .doc-link {
    display: inline-flex;
    align-items: center;
    color: #1677ff;
    text-decoration: none;
    margin-left: 4px;
    font-weight: 500;
    vertical-align: baseline;

    .doc-icon {
      font-size: 13px;
      margin-right: 3px;
    }

    &:hover {
      text-decoration: underline;
      color: #0958d9;
    }
  }

  .shop-info-list {
    margin: 0;
    padding-left: 20px;
    max-width: 980px;

    li {
      margin-bottom: 12px;
      font-size: 14px;
      line-height: 1.7;
      color: #262626;

      &:last-child {
        margin-bottom: 0;
      }

      .field-title {
        font-weight: 600;
        color: #1f1f1f;
      }
    }
  }
}

@media only screen and (max-width: 768px) {
  .entry-info-container {
    padding: 24px 16px;

    .main-title {
      font-size: 22px;
      margin-bottom: 24px;
    }

    .section-block {
      margin-bottom: 28px;

      .sub-title {
        font-size: 16px;
        margin-bottom: 12px;
      }
    }

    .info-table {
      th,
      td {
        padding: 10px 12px;
        font-size: 12px;
      }
    }
  }
}
</style>
